<!-- Expand/Fold Carets -->
@if (isExpanded) {
    <a (click)="isExpanded = false" class="me-1 caret"><i class="fa-solid fa-caret-down"></i></a>
} @else {
    <a (click)="isExpanded = true" class="me-1 caret"><i class="fa-solid fa-caret-right"></i></a>
}

<!-- Beginning of the object: '{' or '[' -->
<span class="pe-2" [ngClass]='array ? "square-bracket-text": "curly-bracket-text"'>{{array ? '[': '{'}}</span>

<!-- If expanded, show content; otherwise show '...' -->
@if (isExpanded) {
    <!-- IF ARRAY -->
    @if (array) {
        <div class="ms-2">
            <!-- Since Array, no property name, just values -->
            @for (item of array; track $index; let i = $index) {
                <div>
                    @switch (item | typeof) {
                        @case ('array') {
                            <!-- Array Index -->
                            <a (click)="picked(i, item, (isLastItem(i, array) ? -1 : i) + '')" class="mx-2" type="button"
                                style="width: 28px;">
                                {{i}}
                            </a>

                            <shared-json-object [json]='json' [array]="item" [isExpanded]="i == 0"
                                (pick)="picked($event.key, $event.value, (isLastItem(i, array) ? -1 : i) + $event.path)">
                            </shared-json-object>
                            @if (i != array.length - 1) {
                                <span>{{','}}</span>
                            }
                        }
                        @case ('object') {
                            {{i + 1}}
                            <shared-json-object [json]="item" [isExpanded]="i == 0 || (json | equals : item)"
                                (pick)="picked($event.key, $event.value, (isLastItem(i, array) ? -1 : i) + '/' + $event.path)">
                            </shared-json-object>
                            @if (i != array.length - 1) {
                                <span>{{','}}</span>
                            }
                        }
                        @default {
                            <!-- Array Index -->
                            <a (click)="picked(i, item, (isLastItem(i, array) ? -1 : i))" class="mx-2" type="button"
                                style="width: 28px;">
                                {{i}}
                            </a>

                            <shared-json-literal [literal]="item"
                                (pick)='picked($event.key, $event.value, (isLastItem(i, array) ? -1 : i))'>
                            </shared-json-literal>
                            @if (i < array.length - 1) {
                                <span class='value-text'>{{','}}</span>
                            }
                        }
                    }
                </div>
            }
        </div>
    } @else {
        <!-- IF OBJECT -->
        <div class="ms-2">
            @for (prop of properties; track prop.propertyName; let i = $index) {
                <div>
                    <!-- Pickable Property Name -->
                    <a (mouseenter)="hovering = i" (mouseleave)="hovering = undefined">
                        <span [ngClass]="hovering == i ? 'property-text-hover' : 'property-text'"
                            (click)="select(prop)">{{prop.propertyName}}</span>
                        <span class="me-2 colon-text"> {{':'}}</span>
                    </a>
                    <!-- Property Values -->
                    @switch (prop.value | typeof) {
                        @case ('array') {
                            <shared-json-object [array]="prop.value" [isExpanded]="i == 0"
                                (pick)='picked($event.key, $event.value, prop.propertyName + "/" + $event.path)'>
                            </shared-json-object>
                        }
                        @case ('object') {
                            <shared-json-object [json]="prop.value" [isExpanded]="i == 0"
                                (pick)='picked($event.key, $event.value, prop.propertyName + "/" + $event.path)'>
                            </shared-json-object>
                            @if (i != properties.length - 1) {
                                <span class="value-text">{{','}}</span>
                            }
                        }
                        @default {
                            <shared-json-literal [literal]="prop.value"
                                (pick)='picked($event.key, $event.value, prop.propertyName + "/" + $event.path)'>
                            </shared-json-literal>
                        }
                    }
                </div>
            }
            <!-- Just a literal -->
            @if (properties.length == 0) {
                <div>{{json}}</div>
            }
        </div>
    }
} @else {
    <span class="value-text">{{'...'}}</span>
}

<!-- End of the object: '}' or ']' -->
<span class="ps-2" [ngClass]='array ? "square-bracket-text": "curly-bracket-text"'>{{array ? ']': '}'}}</span>
